/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon20Solid = forwardRef('MailIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm.52 2.598a.75.75 0 1 0-.931 1.176l3.394 2.687a3.25 3.25 0 0 0 4.034 0l3.394-2.687a.75.75 0 1 0-.93-1.176l-3.395 2.687a1.75 1.75 0 0 1-2.172 0L5.52 6.598Z" })));
});
